import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

import { IconButton, TablePagination } from "@mui/material";
import { ChevronLeft, ChevronRight, FirstPage, LastPage } from "@mui/icons-material";

import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";

const { dark } = colors;

function TablePaginationActions({ count, page, rowsPerPage, onPageChange }) {
  const totalPages = Math.ceil(count / rowsPerPage);

  const btnSx = {
    p: "3px",
    m: 0,
    color: dark.main,

    "&:hover": {
      background: "rgba(255,255,255,0.08)",
      color: dark.main,
    },

    "&.Mui-disabled": {
      color: rgba(dark.main, 0.35),
    },
  };

  return (
    <VuiBox display="flex" alignItems="center" ml={1.5}>
      <IconButton onClick={(event) => onPageChange(event, 0)} disabled={page === 0} sx={btnSx}>
        <FirstPage fontSize="small" />
      </IconButton>

      <IconButton
        onClick={(event) => onPageChange(event, page - 1)}
        disabled={page === 0}
        sx={btnSx}
      >
        <ChevronLeft fontSize="small" />
      </IconButton>

      <IconButton
        onClick={(event) => onPageChange(event, page + 1)}
        disabled={page >= totalPages - 1}
        sx={btnSx}
      >
        <ChevronRight fontSize="small" />
      </IconButton>

      <IconButton
        onClick={(event) => onPageChange(event, totalPages - 1)}
        disabled={page >= totalPages - 1}
        sx={btnSx}
      >
        <LastPage fontSize="small" />
      </IconButton>
    </VuiBox>
  );
}

const CardPagination = ({
  page = 0,
  rowsPerPage = 10,
  total = 0,
  onPageChange,
  onRowsPerPageChange,
  loading = false,
}) => {
  return (
    <VuiBox
      mt="auto"
      pt={2}
      pb={1}
      pr={1}
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      gap={1.25}
    >
      <VuiBox
        display="flex"
        alignItems="center"
        gap={0.75}
        sx={{
          height: "34px",
          px: 1.25,
          borderRadius: "10px",
          background: "linear-gradient(135deg, rgba(255,255,255,0.10), rgba(255,255,255,0.03))",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          border: "1px solid rgba(255,255,255,0.15)",
        }}
      >
        <VuiTypography
          variant="caption"
          sx={{
            color: dark.main,
            opacity: 0.7,
          }}
        >
          Rows
        </VuiTypography>

        <select
          value={rowsPerPage}
          disabled={loading}
          onChange={(event) => onRowsPerPageChange(Number(event.target.value))}
          style={{
            background: "transparent",
            color: dark.main,
            border: "none",
            outline: "none",
            fontSize: "0.75rem",
            cursor: loading ? "not-allowed" : "pointer",
            opacity: loading ? 0.5 : 1,
          }}
        >
          {[5, 10, 25].map((value) => (
            <option
              key={value}
              value={value}
              style={{
                color: dark.main,
                background: "#ffffff",
              }}
            >
              {value}
            </option>
          ))}
        </select>
      </VuiBox>

      <TablePagination
        component="div"
        disabled={loading}
        count={total}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[]}
        ActionsComponent={TablePaginationActions}
        onPageChange={(_, newPage) => onPageChange(newPage)}
        onRowsPerPageChange={(event) => onRowsPerPageChange(Number(event.target.value))}
        sx={{
          minHeight: "34px",
          color: dark.main,

          "& .MuiTablePagination-toolbar": {
            minHeight: "34px",
            paddingLeft: 0,
            paddingRight: 0,
          },

          "& .MuiTablePagination-spacer": {
            display: "none",
          },

          "& .MuiTablePagination-displayedRows": {
            fontSize: "0.75rem",
            color: dark.main,
            margin: 0,
          },

          "& .MuiTablePagination-actions": {
            marginLeft: "5px",
          },

          "& .MuiIconButton-root": {
            padding: "4px",
            color: dark.main,
          },

          "& .MuiIconButton-root.Mui-disabled": {
            color: rgba(dark.main, 0.35),
          },
        }}
      />
    </VuiBox>
  );
};

export default CardPagination;
